export const LANDING_PAGE = "Landing Page";
export const CART_PAGE = "Cart Page";
export const SUBMIT_CONTACT = "User Submitted Contact Form";
export const SUBMIT_CREDIT = "User Submitted Credit Form";

export const CART_FAST_TRACK = "Fast Track Added to Cart";
export const CART_SCRIPT_BUILDER = "Script Builder Added to Cart";
export const CART_SO_DIGITAL = "SO Digital Added to Cart";
export const CART_SLSC = "SLSC Added to Cart";
export const CART_SLP = "SLP Added to Cart";
export const CART_SLM = "SLM Added to Cart";
export const CART_FAST_TRACK_SPANISH = "Fast Track Spanish Added to Cart";
export const CART_SLSC_SPANISH = "SLSC Spanish Added to Cart";
export const CART_SCRIPT_BUILDER_SPANISH = "SLSC Spanish Added to Cart";


export const displayEvents = [
    LANDING_PAGE,
    CART_PAGE,
    SUBMIT_CONTACT,
    SUBMIT_CREDIT,
    CART_FAST_TRACK,
    CART_SCRIPT_BUILDER,
    CART_SO_DIGITAL,
    CART_SLSC,
    CART_SLP,
    CART_SLM,
    CART_FAST_TRACK_SPANISH,
    CART_SLSC_SPANISH,
    CART_SCRIPT_BUILDER_SPANISH
];
